// extracted by mini-css-extract-plugin
export var attachment = "_o6-a";
export var emailContainer = "_o6-4";
export var emailContentPaddedContainer = "_o6-b";
export var emailHeader = "_o6-6";
export var emailIframe = "_o6-3";
export var emailInfoIcon = "_o6-9";
export var emailShortenedSummary = "_o6-e";
export var infoDropdown = "_o6-0";
export var infoRowBoundedContent = "_o6-d";
export var internal = "_o6-5";
export var merchant = "_o6-8";
export var messageInputContainer = "_o6-h";
export var normal = "_o6-7";
export var replyCard = "_o6-f";
export var subtleButton = "_o6-1";
export var subtleButtonIconContainer = "_o6-2";
export var toggleViewRepliesButton = "_o6-c";
export var wrappingText = "_o6-g";